import { injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import { TaskTemplateFilterState } from "Store/TaskTemplates/TaskTemplateFilterState";
import { ITaskTemplateFilterFactory } from "./ITaskTemplateFilterFactory";

@injectable()
export class TaskTemplateFilterFactory implements ITaskTemplateFilterFactory {
    public create(filterState: TaskTemplateFilterState): TemplateFilter {
        return {
            skip: filterState.skip,
            take: filterState.take,
            query: filterState.query,

            recurrenceTypes: filterState.recurrenceTypes,
            areaIds: this.getAreaIds(filterState.area),
            roles: filterState.roles,
            instructionsAttached: filterState.instructionsAttached,
            photoAttached: filterState.photoAttached,
            videoAttached: filterState.videoAttached
        };
    }

    private getAreaIds(selectedArea?: Area): number[] | undefined {
        if (selectedArea) {
            const getAreaIdsOfArea = (area: Area): number[] => {
                const arr = [area.id];

                if (area.children) {
                    return arr.concat(...area.children.map(x => getAreaIdsOfArea(x)));
                }

                return arr;
            };

            return getAreaIdsOfArea(selectedArea);
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/Factories/Tasks/TaskTemplateFilterFactory.ts